<button
  [type]="type()"
  class="square-icon-btn square-icon-btn--{{ variant() }}"
  [class.square-icon-btn--disabled]="disabled()"
  [attr.aria-label]="ariaLabel() || tooltip() || null"
  [attr.aria-disabled]="disabled() ? 'true' : null"
  [andorTooltip]="tooltip()"
  [tooltipTitle]="tooltipTitle()"
  [tooltipVariant]="tooltipVariant()"
  [tooltipPosition]="tooltipPosition()"
  [tooltipDisabled]="tooltipDisabled()"
  (click)="onClick($event)">
  <ng-content></ng-content>
</button>
